/**
 * Компонент для сброса скролла при смене маршрута
 *
 * Ищет ближайший скролл-контейнер (overflow-y-auto) и скроллит его наверх
 * при каждой смене location.pathname
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

export function ScrollToTop(): null {
  const { pathname } = useLocation();
  const prevPathRef = useRef(pathname);

  useEffect(() => {
    // Не скроллим при первом рендере (только при смене маршрута)
    if (prevPathRef.current === pathname) return;
    prevPathRef.current = pathname;

    // Скроллим основной скролл-контейнер layout'а
    const scrollContainer = document.querySelector('[data-scroll-container]');
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0 });
    } else {
      // Fallback: скроллим все overflow-y-auto контейнеры на странице
      document.querySelectorAll('[class*="overflow-y-auto"]').forEach((el) => {
        el.scrollTo({ top: 0 });
      });
    }

    // Всегда скроллим window — для страниц без скролл-контейнера (FullscreenLayout)
    window.scrollTo({ top: 0 });
  }, [pathname]);

  return null;
}